import { render } from "./PointCardExchange.vue?vue&type=template&id=4f5dd8fc&scoped=true"
import script from "./PointCardExchange.vue?vue&type=script&lang=js"
export * from "./PointCardExchange.vue?vue&type=script&lang=js"

import "./PointCardExchange.vue?vue&type=style&index=0&id=4f5dd8fc&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5dd8fc"]])

export default __exports__